import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatResultSummaryDefaultVariants = {
  "status": "success"
}
const chatResultSummaryCompoundVariants = []

const chatResultSummarySlotNames = [
  [
    "root",
    "chatResultSummary__root"
  ],
  [
    "header",
    "chatResultSummary__header"
  ],
  [
    "icon",
    "chatResultSummary__icon"
  ],
  [
    "headings",
    "chatResultSummary__headings"
  ],
  [
    "title",
    "chatResultSummary__title"
  ],
  [
    "summary",
    "chatResultSummary__summary"
  ],
  [
    "badges",
    "chatResultSummary__badges"
  ],
  [
    "actions",
    "chatResultSummary__actions"
  ],
  [
    "followUps",
    "chatResultSummary__followUps"
  ],
  [
    "followUpLabel",
    "chatResultSummary__followUpLabel"
  ],
  [
    "followUpList",
    "chatResultSummary__followUpList"
  ]
]
const chatResultSummarySlotFns = /* @__PURE__ */ chatResultSummarySlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatResultSummaryDefaultVariants, getSlotCompoundVariant(chatResultSummaryCompoundVariants, slotName))])

const chatResultSummaryFn = memo((props = {}) => {
  return Object.fromEntries(chatResultSummarySlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatResultSummaryVariantKeys = [
  "status"
]
const getVariantProps = (variants) => ({ ...chatResultSummaryDefaultVariants, ...compact(variants) })

export const chatResultSummary = /* @__PURE__ */ Object.assign(chatResultSummaryFn, {
  __recipe__: false,
  __name__: 'chatResultSummary',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatResultSummaryVariantKeys,
  variantMap: {
  "status": [
    "success",
    "partial",
    "failed"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chatResultSummaryVariantKeys)
  },
  getVariantProps
})